// client/src/components/login/LoginPage.js
import React from 'react';
import LoginForm from './LoginForm';
import { useAuth } from '../../context/AuthContext';
import { Navigate, useLocation } from 'react-router-dom';
import LoadingSpinner from '../common/LoadingSpinner';
import './LoginPage.css'

function LoginPage() {
    const { user, loading } = useAuth(); // Get user and loading state

    // --- Add console log here ---
    console.log('[LoginPage] Rendering - Loading:', loading, 'User:', user);

    const location = useLocation();
    const from = location.state?.from?.pathname || '/dashboard';

    // Show loading spinner while context might be initializing
    if (loading) {
        console.log('[LoginPage] Showing LoadingSpinner because loading is true');
        return <LoadingSpinner />;
    }

    // Redirect if loading is done and user exists
    if (user) {
        console.log('[LoginPage] User exists, redirecting to:', from);
        return <Navigate to={from} replace />;
    }

    // Render login form if not loading and no user
    console.log('[LoginPage] Not loading and no user, rendering LoginForm');
    return (
        <div className="login-page">
            <LoginForm />
        </div>
    );
}

export default LoginPage;